export default "__VITE_ASSET__DgRWLfG8__"